export default __webpack_public_path__ + "static/media/03.1c67b250.jpg";